// @ts-nocheck
/* home ts */
import "../../sass/pages/home.scss";
import Swiper, { EffectFade, Navigation, Pagination, Autoplay } from "swiper";

import SplitText from "../components/splitTexts";
import * as AOS from "aos";

import "aos/dist/aos.css";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/effect-fade";
import "swiper/css/autoplay";

window.addEventListener("load", () => {
  home();
  sendHomeDataLayer();
  cambiarTextoH3();
  new SplitText(".st__title_home_2");
  new SplitText(".st__title_home_4");
  new SplitText(".st__title_home_6");
  // new SplitText(".st__parr_home_2")

  AOS.init({
    once: true,
  });
});

function cambiarTextoH3() {
  const btnsTitle = document.querySelectorAll(".storename");
  console.log("storename", btnsTitle);
  btnsTitle.forEach((btn) => {
    if (btn.textContent.includes("tadadelivery")) {
      btn.textContent = "Comprar en Tada Delivery";
    } else if (btn.textContent.includes("beerhouse")) {
      btn.textContent = "Comprar en Beerhouse";
    }
  });
}

function home() {
  const swiperBanner = new Swiper(".home_banner_slider", {
    modules: [EffectFade, Navigation, Pagination, Autoplay],
    slidesPerView: 1,
    // effect:"fade",
    // loop:true,
    speed: 1000,
    pagination: {
      el: ".home_banner_slider .swiper-pagination",
      clickable: true,
      renderBullet: (index, className) =>
        `<span class="bullet-loader bullet-animation ${className}"><svg class="svg"><circle r="11" cx="12" cy="12"/></svg></span>`,
    },
    autoplay: {
      delay: 5000,
      // disableOnInteraction: false,
    },
    navigation: {
      nextEl: ".home_banner_slider .swiper-button-next",
      prevEl: ".home_banner_slider .swiper-button-prev",
    },
  });

  const swiper_section_3 = new Swiper(".section_3", {
    modules: [Navigation, Pagination, Autoplay],
    slidesPerView: 1,
    spaceBetween: 45,
    autoHeight: true,
    loop: true,
    speed: 1000,
    autoplay: {
      delay: 5000,
      // disableOnInteraction: false,
    },
    pagination: {
      el: ".section_3 .swiper-pagination",
      clickable: true,
      renderBullet: (index, className) =>
        `<span class="bullet-loader bullet-animation ${className}"><svg class="svg"><circle r="11" cx="12" cy="12"/></svg></span>`,
    },
    navigation: {
      nextEl: ".section_3 .swiper-button-next",
      prevEl: ".section_3 .swiper-button-prev",
    },
  });

  const swiperEventos = new Swiper(".eventos_slider", {
    modules: [Navigation, Pagination],
    slidesPerView: 1,
    spaceBetween: 0,
    autoHeight: true,
    breakpoints: {
      768: {
        slidesPerView: 2,
        spaceBetween: 20,
      },
      991: {
        slidesPerView: 2,
        spaceBetween: 50,
      },
      1200: {
        slidesPerView: 3,
        spaceBetween: 80,
      },
    },
    direction: "horizontal",
    navigation: {
      nextEl: ".eventos_slider .swiper-button-next",
      prevEl: ".eventos_slider .swiper-button-prev",
    },
  });

  const swiperReserva = new Swiper(".reserva_slider", {
    modules: [EffectFade, Navigation, Pagination],
    slidesPerView: 1,
    // effect:"fade",
    spaceBetween: 20,
    direction: "horizontal",
    navigation: {
      nextEl: ".slider_home_reserva .swiper-button-next",
      prevEl: ".slider_home_reserva .swiper-button-prev",
    },
    pagination: {
      el: ".slider_home_reserva .swiper-pagination",
      renderBullet: function (index, className) {
        return '<span class="' + className + '"></span>';
      },
    },
  });
  const paginationSliderReserva = document.querySelector(
    ".slider_home_reserva .swiper-pagination"
  );
  paginationSliderReserva.setAttribute(
    "data-index",
    `0${swiperReserva.snapIndex + 1}`
  );
  paginationSliderReserva.setAttribute(
    "data-total",
    `${swiperReserva.snapIndex <= 8 ? 0 : ""}${swiperReserva.slides.length}`
  );
  swiperReserva.on("slideChange", () => {
    paginationSliderReserva.setAttribute(
      "data-index",
      `${swiperReserva.snapIndex <= 8 ? 0 : ""}${swiperReserva.snapIndex + 1}`
    );
  });

  const swiperProductos = new Swiper(".productos_slider", {
    modules: [Navigation, Pagination],
    slidesPerView: 1,
    slidesPerGroup: 1,
    spaceBetween: 40,
    breakpoints: {
      // when window width is >= 480px
      900: {
        slidesPerView: 2,
        spaceBetween: 30,
        slidesPerGroup: 2,
      },
      // when window width is >= 640px
      1200: {
        slidesPerView: 3,
        spaceBetween: 40,
        slidesPerGroup: 3,
      },
    },
    direction: "horizontal",
    navigation: {
      nextEl: ".productos_slider .swiper-button-next",
      prevEl: ".productos_slider .swiper-button-prev",
    },
  });
}

const sendHomeDataLayer = () => {
  //dataLayer boton Conoce nuestra Historia
  const historyBtn = document.getElementById("access_history_btn");
  if (historyBtn) {
    historyBtn.addEventListener("click", () => {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: "GAEvent",
        event_category: "Content",
        event_action: "Content",
        event_label: `Conoce nuestra historia XXXXXX`,
        interaction: "true",
        component_name: "Home-Conoce nuestra historia",
        element_text: "Conoce nuestra historia",
      });
    });
  }

  //dataLayer card productos tienda
  const cardProduct = document.querySelectorAll(".cardlink");
  if (cardProduct) {
    cardProduct.forEach((btn) => {
      btn.addEventListener("click", (e) => {
        console.log("cardlink", dataLayer);
        const dataMarketAttribute = btn.getAttribute("data-market");
        const dataNameAttribute = btn.getAttribute("data-name");
        const dataText = document.querySelector(".storename").textContent;
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: "GAEvent",
          event_category: "Content",
          event_action: "Content",
          event_label: `${dataText}`,
          interaction: "true",
          component_name: `${dataNameAttribute}`,
          element_text: `${dataText}`,
          product: `${dataNameAttribute}`,
        });
      });
    });
  }

  //dataLayer card productos tienda
  const cardProduct = document.querySelectorAll(".cardlink");
  if (cardProduct) {
    cardProduct.forEach(btn => {
      btn.addEventListener("click", (e) => {
        console.log('cardlink', dataLayer);
        const dataMarketAttribute = btn.getAttribute("data-market");
        const dataNameAttribute = btn.getAttribute("data-name");
        const dataText = document.querySelector(".storename").textContent;
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: "GAEvent",
          event_category: "Content",
          event_action: "Content",
          event_label: `${dataText}`,
          interaction: "true",
          component_name: `${dataNameAttribute}`,
          element_text: `${dataText}`,
          product: `${dataNameAttribute}`,
        }); 
      })
    })
  }

  //dataLayer boton slider section 1 (banner)
  const btnSlidebanner = document.querySelectorAll(
    ".home_banner_slider .btn_st"
  );
  if (btnSlidebanner) {
    btnSlidebanner.forEach((btn) => {
      btn.addEventListener("click", (e) => {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: "GAEvent",
          event_category: "Content",
          event_action: "Content",
          event_label: `${e.target.innerText}`,
          interaction: "true",
          component_name: `${e.target.innerText}`,
          element_text: `${e.target.innerText}`,
        });
      });
    });
  }
  //dataLayer boton slider section 3 (reserva)
  const btnSlideReserva = document.querySelectorAll(".reserva_slider .btn_st");
  if (btnSlideReserva) {
    btnSlideReserva.forEach((btn) => {
      btn.addEventListener("click", (e) => {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: "GAEvent",
          event_category: "Content",
          event_action: "Content",
          event_label: `${e.target.innerText}`,
          interaction: "true",
          component_name: `${e.target.innerText}`,
          element_text: `${e.target.innerText}`,
        });
      });
    });
  }
  //dataLayer boton slider section 3
  const slideBtnSt3 = document.querySelectorAll(".section_3 .btn_st");
  if (slideBtnSt3) {
    slideBtnSt3.forEach((btn) => {
      btn.addEventListener("click", (e) => {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: "GAEvent",
          event_category: "Content",
          event_action: "Content",
          event_label: `${e.target.innerText}`,
          interaction: "true",
          component_name: `${e.target.innerText}`,
          element_text: `${e.target.innerText}`,
        });
      });
    });
  }

  //dataLayer productos: única vez cuando el usuario  hace clic sobre el logo de  Ta Da  o  Beerhouse
  const productItems = document.querySelectorAll(".productos_slider .card_st");
  if (productItems) {
    productItems.forEach((btn) => {
      btn.addEventListener("click", (e) => {
        const title = btn.querySelector(".producto_title");
        if (e.target.tagName !== "IMG") return;
        if (
          e.target.alt.includes("TaDa") ||
          e.target.alt.includes("Beerhouse")
        ) {
          const store = e.target.alt.split(" ")[1];

          // console.log(title);
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({
            event: "GAEvent",
            event_category: "Content External",
            event_action: "Content",
            event_label: `Comprar en ${store}`,
            interaction: "true",
            component_name: `Comprar en ${store}`,
            element_text: `Comprar en ${store}`,
            product: `${title.innerText}`,
          });
        }
      });
    });
  }
};
